<template>
    <div v-if="!loading && alerts.length">
        <div v-for="alert in alerts" :key="alert.name" :class="['alert alert-dismissible fade show', 'alert-'+alert.class]" 
            role="alert">
            <a :href="alert.route" class="">
                <span class="font-weight-bold text-dark">{{alert.name}}</span>
                <p class="font-weight-light mb-0 text-dark">{{alert.description}}</p>
            </a>
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "PageAlerts",

    props: {
    },

    data() {
        return {
            alerts: [],
            loading: true,
        }
    },

    created() {
        this.loadPageAlerts()
    },

    methods: {
        loadPageAlerts() {
            this.loading = true;
            var self = this;
            axios.get('api/pagealerts')
            .then(function (response) {
                self.loading = false;
                // convert to an array (so we can easily get the length)
                self.alerts = response.data.data;
            })
            .catch(function (error) {
                console.log(error);
                self.error = true;
            });
        }
    }
}
</script>